module.exports = __webpack_public_path__ + "static/old-logo-a04f24adb0329785f824726f6c85780d.jpg";